"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
function PostsGridConsumer() {
  const {
    posts,
    loading,
    error,
    refetch
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
        {[...Array(3)].map((_, i) => <Card key={i} data-index={i} className="flex flex-col gap-0 p-0 rounded-none border border-border/50 shadow-none bg-card">
            <AspectRatio ratio={1}>
              <div className="h-full w-full bg-muted animate-pulse" />
            </AspectRatio>
            <div className="flex flex-col p-6 flex-grow">
              <div className="h-5 w-16 bg-muted animate-pulse mb-4 rounded-none" />
              <div className="h-6 w-3/4 bg-muted animate-pulse mb-2 rounded-none" />
              <div className="h-6 w-1/2 bg-muted animate-pulse mb-6 rounded-none" />
              <div className="mt-auto h-4 w-24 bg-muted animate-pulse rounded-none" />
            </div>
          </Card>)}
      </div>;
  }
  if (error) {
    return <div className="text-center py-12">
        <p className="text-muted-foreground mb-4 font-serif">Não foi possível carregar os insights estratégicos.</p>
        <button onClick={refetch} className="text-primary underline hover:text-primary/80 transition-colors font-serif">
          Tentar novamente
        </button>
      </div>;
  }
  if (posts.length === 0) {
    return <div className="text-center py-12">
        <p className="text-muted-foreground font-serif">Nenhum conteúdo disponível no momento.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
      {posts.map((post, i) => <Card key={post.id} data-index={i} className="group flex flex-col gap-0 p-0 overflow-hidden rounded-none border border-border/40 bg-card shadow-sm transition-all duration-500 hover:shadow-xl hover:border-primary/20">
          <Link to={post.link || "#"} className="block overflow-hidden">
            <AspectRatio ratio={1}>
              <img src={post.featuredImage || "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/executive_leadership_insight.png"} alt={post.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110 grayscale hover:grayscale-0" />
            </AspectRatio>
          </Link>
          
          <div className="flex flex-col p-6 flex-grow">
            <div className="mb-4">
              {post.categories && post.categories.length > 0 && <Badge variant="secondary" className="rounded-none px-3 py-1 text-[10px] uppercase tracking-[0.2em] font-bold bg-secondary text-secondary-foreground">
                  {post.categories[0].name}
                </Badge>}
            </div>
            
            <h3 className="font-serif text-2xl font-medium leading-tight text-foreground mb-6">
              <Link to={post.link || "#"} className="hover:text-primary transition-colors">
                {post.title}
              </Link>
            </h3>
            
            <div className="mt-auto">
              <Link to={post.link || "#"} className="group/link inline-flex items-center text-xs font-bold text-foreground uppercase tracking-[0.15em] hover:text-primary transition-colors">
                Explorar Artigo
                <ArrowRight className="ml-2 size-3 transition-transform duration-300 group-hover/link:translate-x-1" />
              </Link>
            </div>
          </div>
        </Card>)}
    </div>;
}
export default function IndustryInsights() {
  const wp_query_params = {
    post_type: "post",
    per_page: 3
  };
  const wp_query = new WP_Query(wp_query_params);
  return;
}